import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../partials/aside/Sidebar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Link } from "react-router-dom";

export default function InfoSiteUserAdvertiser() {
  const [siteUserAdvertiser, setSiteUserAdvertiser] = useState();
  const params = useParams();
  const siteAdvertiserID = params.siteAdvertiserID;
  const history = useHistory();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    getInfoSiteUserAdvertiser(siteAdvertiserID);
  }, []);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendFormRequestEditSiteUserAdvertiser = async (
    siteAdvertiserID,
    dataForm
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/site-user-advertiser/" +
          siteAdvertiserID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getDataForm = () => {
    return {
      state: document.querySelector("#state").value,
      message: document.querySelector("#message").value,
    };
  };

  const getInfoSiteUserAdvertiser = async (siteAdvertiserID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetInfoSiteUserAdvertiser =
      await sendRequestGetInfoSiteUserAdvertiser(siteAdvertiserID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetInfoSiteUserAdvertiser) {
      return;
    }
    const htmlTag = `<script class="hilite-script" data-hilite="${resultSendRequestGetInfoSiteUserAdvertiser.hashIDScript}" src="https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js"></script>`;

    setSiteUserAdvertiser({
      ...resultSendRequestGetInfoSiteUserAdvertiser,
      htmlTag: htmlTag,
    });
  };

  const sendRequestGetInfoSiteUserAdvertiser = async (siteAdvertiserID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/site-user-advertiser/" +
          siteAdvertiserID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendFormRequestEditSiteUserAdvertiser =
      await sendFormRequestEditSiteUserAdvertiser(siteAdvertiserID, dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendFormRequestEditSiteUserAdvertiser) {
      return;
    }

    history.push(
      "/user/manage/" + siteUserAdvertiser.sua_user_id + "/site-advertiser"
    );
  };

  const generateSiteUserAdvertiser = (siteUserAdvertiser) => {
    return (
      <div>
        <div className="text-left pb-2">
          <Link
            className="text-white"
            to={`/user/manage/${siteUserAdvertiser.sua_user_id}/site-advertiser`}
          >
            <div className="btn btn-primary">
              <span>
                <span className="text-white">بازگشت</span>
              </span>
              <span className="pr-2">
                <i className="fas fa-arrow-left" aria-hidden="true"></i>
              </span>
            </div>
          </Link>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite m-0">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  {" "}
                  اطلاعات سایت تبلیغ دهنده کاربر
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره سایت تبلیغ دهنده</td>
                <td>{siteUserAdvertiser.sua_id}</td>
              </tr>

              <tr>
                <td>آدرس سایت</td>
                <td>
                  {
                    <>
                      {siteUserAdvertiser.sua_site_url}
                      <a
                        className="btn btn-primary mr-2"
                        href={siteUserAdvertiser.sua_site_url}
                        target="_blank"
                      >
                        <i className="fa fa-link"></i>
                      </a>
                    </>
                  }
                </td>
              </tr>

              <tr>
                <td>حالت</td>
                <td>{siteUserAdvertiser.sua_state}</td>
              </tr>

              <tr>
                <td>اسکریپت</td>
                <td dir="ltr" className="text-left">
                  <span className="pr-2">{siteUserAdvertiser.htmlTag}</span>
                  <span>
                    <button
                      className="btn btn-info"
                      onClick={(e) => {
                        e.preventDefault();
                        navigator.clipboard.writeText(
                          siteUserAdvertiser.htmlTag
                        );
                        setCopied(true);
                      }}
                    >
                      <i className="fas fa-copy pr-2"></i>
                      {copied ? "کپی شد" : " کپی  "}{" "}
                    </button>
                  </span>
                </td>
              </tr>

              <tr>
                <td>پیغام</td>
                <td>{siteUserAdvertiser.sua_message}</td>
              </tr>

              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helpersNumber.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      siteUserAdvertiser.sua_created_at
                    ) +
                      " " +
                      siteUserAdvertiser.sua_created_at.split(" ")[1]
                  )}
                </td>
              </tr>

              <tr>
                <td>تاریخ آخرین بروزرسانی</td>
                <td>
                  {helpersNumber.toPersianNum(
                    helpersTime.convertGregorianToJalali(
                      siteUserAdvertiser.sua_updated_at
                    ) +
                      " " +
                      siteUserAdvertiser.sua_updated_at.split(" ")[1]
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
        <div className="pt-2">
          <form
            className="p-2 border border-1"
            onSubmit={(e) => {
              e.preventDefault();
              sendForm();
            }}
          >
            <h1 className="text-dark py-2"> تغییر حالت سایت تبلیغ دهنده</h1>
            <div>
              <p className="alert alert-warning m-0">
                در صورت رد کردن حتما دلیل خود را برای کاربر بنویسید
              </p>
            </div>
            <div className="py-2">
              <select id="state" className="form-control w-auto">
                <option value="2">تایید</option>
                <option value="3">رد</option>
              </select>
            </div>
            <div className="pb-2">
              <div className="py-2">پیغام</div>
              <textarea
                id="message"
                name="message"
                placeholder="پیغام"
                className="form-control pb-2"
              ></textarea>
            </div>
            <div>
              <button className="btn btn-primary">ثبت</button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اطلاعات سایت تبلیغ دهنده کاربر
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {!siteUserAdvertiser == true ? (
                <></>
              ) : (
                generateSiteUserAdvertiser(siteUserAdvertiser)
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
